import { getPerspectiveId } from "@app/lib/perspective";
import NeedsReviewPage, {
  PAGE_SIZE,
  needsReviewQuery,
} from "@app/pages/needs-review/needs-review-page";
import type { needsReviewPage_Query } from "@app/queries/needsReviewPage_Query.graphql";
import { environment } from "@app/relay/relay-environment";
import { pageHead } from "@app/lib/page-title";
import { createFileRoute } from "@tanstack/react-router";
import { Suspense } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { loadQuery } from "react-relay";

export const Route = createFileRoute("/_authed/needs-review")({
  loader: () =>
    loadQuery<needsReviewPage_Query>(
      environment,
      needsReviewQuery,
      {
        perspectiveId: getPerspectiveId() ?? undefined,
        // Match the page's initial sort + page size so page 0 (the preloaded page)
        // is consistent with the pager and every subsequent fetch.
        sort: "DATE",
        sortDirection: "DESC",
        limit: PAGE_SIZE,
        offset: 0,
      },
      { fetchPolicy: "network-only" }
    ),
  head: () => pageHead("Needs review"),
  component: NeedsReviewRoute,
});

function NeedsReviewRoute() {
  const queryRef = Route.useLoaderData();

  return (
    <ErrorBoundary
      fallback={
        <div className="p-6 text-red-500">Error loading the needs-review worklist</div>
      }
    >
      <Suspense
        fallback={
          <div className="p-6 text-gray-500">Loading the needs-review worklist...</div>
        }
      >
        <NeedsReviewPage queryRef={queryRef} />
      </Suspense>
    </ErrorBoundary>
  );
}
